/**
 * Public Discord invite links shown on the contact page.
 *
 * These are *invite links* (users join the server), NOT webhooks. The webhook
 * URLs used to post submission notifications live in env vars — see
 * src/lib/discord-webhook.ts.
 */
export const DISCORD_LINKS = {
  general: "https://discord.gg/dJQZa9hK6k",
  toolIdeas: "https://discord.gg/Vxxn77zZ93",
  bugReports: "https://discord.gg/KhpZ6BywVD",
  f1Fantasy: "https://discord.gg/xZMsMMH5We",
} as const;
